var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYodaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0yl{fill:#588443;}\r\n\t.st1yl{fill:#3F8E38;}\r\n\t.st2yl{fill:#3E8436;}\r\n\t.st3yl{fill:#3A7231;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0yl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1yl",
    d: "M138.7,98.4c-1.3-1.1-3.4-2.5-6.2-2.9c-2.3-0.3-7-0.3-15.3,7.3c-4.6,4.2-12,12.2-17.6,25.9 c-3.5,5.2-7.7,13.1-9.8,23.2c-1.2,5.9-2.7,14.9,0.4,25.5c0.8,2.8,2.6,7.2,6.3,11.5c6.7,7.7,15.2,9.7,18.2,10.2 c4.1,0.8,8.9,2.1,14,4.2c3.5,1.4,6.5,2.9,9.2,4.4c2.3,1.2,6.5,2.9,11.9,3.1c0.3,0,0.6,0,0.9,0v-121 C145.3,89.9,140.6,93.3,138.7,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2yl",
    d: "M212.7,165c-1-8.2-3.3-19.9-9.2-32.8c-6.3-13.9-14.2-23.8-20.1-30.1c-0.7-0.8-5.4-6.3-12.8-6 c-3.4,0.1-5.9,1.4-7.3,2.3c-1.9-5.1-6.8-8.6-12.3-8.6c-0.1,0-0.2,0-0.4,0v121c6.4,0.1,11.2-2,13.5-3.2c3.4-2,8.1-4.4,14-6.1 c4.7-1.3,8.9-1.9,12.3-2.1c2.2-0.8,15.7-5.8,20.7-19.6C213.4,173.8,213.2,168.3,212.7,165z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2yl",
    d: "M192,122.2c7.3-4.2,13.6-6.3,17.7-7.4c20.1-5.4,32.3,0.7,60.2-1.2c7.6-0.5,13.7-1.5,17.3-2.1 c-3.9,5.8-8.7,11.9-14.4,18.2c-13.9,15-28.5,24.8-40.1,31.1c-2.8,1.1-6.9,2.4-11.9,2.7c-8.5,0.5-15.2-2-18.6-3.6 C198.8,147.4,195.4,134.8,192,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1yl",
    d: "M108,122.2c-7.3-4.2-13.6-6.3-17.7-7.4c-20.1-5.4-32.3,0.7-60.2-1.2c-7.6-0.5-13.7-1.5-17.3-2.1 c3.9,5.8,8.7,11.9,14.4,18.2c13.9,15,28.5,24.8,40.1,31.1c2.8,1.1,6.9,2.4,11.9,2.7c8.5,0.5,15.2-2,18.6-3.6 C101.2,147.4,104.6,134.8,108,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3yl",
    d: "M203.4,128c5-2.9,9.3-4.3,12.2-5.1c13.8-3.7,22.2,0.5,41.4-0.8c5.2-0.4,9.4-1,11.9-1.4 c-2.7,4-5.9,8.2-9.9,12.5c-9.5,10.3-19.6,17.1-27.6,21.4c-2,0.8-4.7,1.7-8.2,1.9c-5.8,0.4-10.4-1.3-12.8-2.4 C208.1,145.3,205.7,136.6,203.4,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3yl",
    d: "M99.5,128c-5-2.9-9.3-4.3-12.2-5.1c-13.8-3.7-22.2,0.5-41.4-0.8c-5.2-0.4-9.4-1-11.9-1.4 c2.7,4,5.9,8.2,9.9,12.5c9.5,10.3,19.6,17.1,27.6,21.4c2,0.8,4.7,1.7,8.2,1.9c5.8,0.4,10.4-1.3,12.8-2.4 C94.8,145.3,97.1,136.6,99.5,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3yl",
    d: "M97.9,148.2c7.4-6.1,17.1-8,25.3-4.6c7.4,3,10.9,9.2,11.9,11.3c0.7,1,0.6,2.3-0.2,3.1 c-0.7,0.7-1.9,0.9-2.8,0.4c-0.6-1.5-3.5-7.8-10.7-10.9c-10-4.2-19.1,1.7-19.8,2.2c-0.9,0.9-2.3,1-3.1,0.4 C97.8,149.4,97.9,148.3,97.9,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3yl",
    d: "M200.7,148.2c-7.4-6.1-17.1-8-25.3-4.6c-7.4,3-10.9,9.2-11.9,11.3c-0.7,1-0.6,2.3,0.2,3.1 c0.7,0.7,1.9,0.9,2.8,0.4c0.6-1.5,3.5-7.8,10.7-10.9c10-4.2,19.1,1.7,19.8,2.2c0.9,0.9,2.3,1,3.1,0.4 C200.8,149.4,200.7,148.3,200.7,148.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYodaLogo);
export default __webpack_public_path__ + "static/media/yoda-logo.f6b39d45.svg";
export { ForwardRef as ReactComponent };